<div class="card">
  <div class="card-body">
    <div class="col-12">
      <div class="row">
        <div class="col-auto d-flex justify-content-start">
          <div class="form-group" >
            <label>{{'header.assesmentyear' | translate }}<span class="required-field">*</span></label>
            <select [(ngModel)]="dgcGraphFilter['ay']" class="form-control custom-selectbox w-100 pointer">
              <option *ngFor="let year of yearDropDownList" value="{{year}}">{{year}}</option>
            </select>
          </div>
        </div>
        <!-- <div class="col-12 col-xl col-md-6">
          <div class="form-group" >
            <label>{{ 'header.state' | translate }}<span class="required-field">*</span></label>
            <select [(ngModel)]="dgcGraphFilter['lu']" class="form-control custom-selectbox w-100">
              <option value="" [disabled]="true">{{ 'tabledataforstates.selectstate' | translate }}</option>
              <option  value="All">{{ 'tabledataforstates.all' | translate }}</option>
              <option  *ngFor="let state of statelists" value="{{state['uuid']}}">{{'tabledataforstates.' + state['name'] | translate }}</option>
            </select>
          </div>
        </div> -->
        
        <div class="form-group">
          <label class="w-100">&nbsp;&nbsp;<span class="required-field"></span></label>
          <button class="btn btn-info pointer" (click)="getGraphData()" type="submit">{{'dataSubs.VIEW' | translate}}</button>         
        </div>      
    </div>

    <div id="double-column-chart" class="mt-5 pointer"></div>
    <hr class="bg-dark">
    <div id="line-chart" class="mt-5 pointer"></div>

    </div>
    </div>
  </div>